// The header is fixed, so anything scrolled to by coordinates has to clear its real height.
// CSS scroll-margin-top covers scrollIntoView; this is for the scripted scrolls.
export const headerOffset = () => document.querySelector('.header__fixed')?.offsetHeight ?? 0;
